import { useMutation } from 'react-query';
import { controlBackdropLoading } from '../../services';
import { containersService, removeCache } from '../../services';
import { ImageObjType } from '../../types';

export const useEditContainerMutation = () => {
  return useMutation(
    ({ slot, tier, ...props }: any) => {
      if (slot) props.slot = slot;
      if (tier) props.tier = tier;

      return containersService.edit(props);
    },
    {
      onSettled: () => {
        removeCache(['container']);
      },
    },
  );
};

export const useRemovePlaceContainerMutation = () => {
  return useMutation((id: string) => containersService.removePlace(id), {
    onSuccess: () => {
      removeCache(['container', 'yard', 'key']);
    },
  });
};

export const useUpdateImagesMutation = () => {
  return useMutation(
    ({ id, photos = [] }: { id: string; photos: ImageObjType[] }) => {
      controlBackdropLoading(1);

      return containersService.updateImages({ id, photos }).then((res: any) => {
        let images = [];
        if (typeof res === 'object') images = res.data.data;

        return images;
      });
    },
    {
      onSuccess: () => {
        removeCache(['container']);
      },
      onSettled: () => {
        controlBackdropLoading(-1);
      },
    },
  );
};

export const useUpdateDocumentsMutation = () => {
  return useMutation(
    ({ id, documents = [] }: { id: string; documents: ImageObjType[] }) => {
      controlBackdropLoading(1);

      return containersService.updateDocuments({ id, documents }).then((res: any) => {
        let docs = [];
        if (typeof res === 'object') docs = res.data.data;

        return docs;
      });
    },
    {
      onSuccess: () => {
        removeCache(['container']);
      },
      onSettled: () => {
        controlBackdropLoading(-1);
      },
    },
  );
};
